export default {
  methods: {
    wrapTextWithHtmlTag(text) {
      return `<strong class="color--text-black-087 pl-4">${text}</strong>`
    }
  }
}
